var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDhroom1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 250,
    height: 250,
    rx: 125,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7448_1906)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.027 58C126.038 58 96.0518 87.9854 96.0518 124.974C96.0518 161.963 126.038 191.949 163.027 191.949C200.016 191.949 230 161.963 230 124.974C230 87.9854 200.016 58 163.027 58ZM163.027 168.315C139.091 168.315 119.687 148.91 119.687 124.974C119.687 101.038 139.091 81.6342 163.027 81.6342C170.906 81.6342 178.286 83.747 184.652 87.4212L192.295 85.3734L204.032 82.2286L200.887 93.9654L199.04 100.859C203.665 107.754 206.366 116.048 206.366 124.974C206.366 148.91 186.963 168.315 163.027 168.315Z",
    fill: "#2F2CD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.35 159.534C150.44 149.446 153.95 137.62 153.95 124.975C153.95 112.329 150.442 100.504 144.35 90.4141C136.806 94.5066 130.756 101.001 127.206 108.859C129.205 113.842 130.315 119.277 130.315 124.975C130.315 130.672 129.205 136.107 127.206 141.09C130.756 148.948 136.806 155.442 144.35 159.534Z",
    fill: "#2F2CD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.211 164.743C98.9273 167.036 93.1015 168.314 86.975 168.314C79.096 168.314 71.7159 166.201 65.3495 162.528L57.7069 164.576L45.9701 167.721L49.1151 155.984L50.9614 149.089C46.3352 142.194 43.6353 133.901 43.6353 124.974C43.6353 101.038 63.039 81.6342 86.975 81.6342C93.1015 81.6342 98.9273 82.9124 104.211 85.2055C108.858 78.3543 114.678 72.366 121.368 67.5033C111.314 61.4736 99.5515 58 86.975 58C49.9861 58 20 87.9856 20 124.974C20 161.963 49.9861 191.949 86.975 191.949C99.5515 191.949 111.314 188.475 121.368 182.446C114.678 177.583 108.858 171.594 104.211 164.743Z",
    fill: "#2F2CD8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7448_1906"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 210,
    height: 134,
    fill: "white",
    transform: "translate(20 58)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDhroom1);
export default __webpack_public_path__ + "static/media/Dhroom1.68ff068d5810f193f498d591bf382537.svg";
export { ForwardRef as ReactComponent };